export default __webpack_public_path__ + "static/media/screen3.604c5a8d.jpg";